import { render, staticRenderFns } from "./radialbar_component.vue?vue&type=template&id=0b7d1544"
import script from "./radialbar_component.vue?vue&type=script&lang=js"
export * from "./radialbar_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports